(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) { return (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }); };
  var slug = function (s) { return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); };
  var countOf = function (sku) { return parseInt(String(sku || '').split('-').pop(), 10) || 1; };
  var body = document.body;

  /* Reveal */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('[data-reveal]').forEach(function (el) { io.observe(el); });
  } else {
    $$('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Header : transparent sur le hero, plein au défilement */
  var top = $('[data-top]');
  if (top && body.classList.contains('tpl-index')) {
    var solid = function () { top.classList.toggle('is-solid', window.scrollY > 40); };
    solid(); window.addEventListener('scroll', solid, { passive: true });
  }

  /* Menu */
  var menu = $('[data-menu]');
  if (menu) {
    $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { menu.hidden = false; body.classList.add('is-locked'); }); });
    $$('[data-menu-close], [data-menu] a').forEach(function (b) { b.addEventListener('click', function () { menu.hidden = true; body.classList.remove('is-locked'); }); });
  }

  /* Drawer */
  var drawer = $('[data-drawer]');
  var dBody = $('[data-drawer-body]');
  var noteEl = $('[data-cart-note]');
  var noteStatus = $('[data-cart-note-status]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-on'); drawer.setAttribute('aria-hidden', 'false'); body.classList.add('is-locked');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-on'); drawer.setAttribute('aria-hidden', 'true'); body.classList.remove('is-locked');
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function lineDetail(it) {
    var p = it.properties || {}, keys = Object.keys(p).filter(function (k) { return k.charAt(0) !== '_' && p[k]; });
    if (!keys.length) return it.variant_title || '';
    var first = (it.variant_title || '').split(' / ')[0];
    return first + ' : ' + keys.map(function (k) { return p[k]; }).join(' · ');
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var tot = $('[data-drawer-total]'); if (tot) tot.textContent = money(cart.total_price);
    var up = $('[data-drawer-upsell]');
    if (up) up.hidden = !(cart.items.length && cart.items.every(function (i) { return countOf(i.sku) === 1; }));
    var co = $('[data-checkout]'); if (co) co.toggleAttribute('hidden', !cart.items.length);
    if (!dBody) return;
    if (!cart.items.length) { dBody.innerHTML = '<p class="ed-drawer__empty">Ton panier est vide.</p>'; return; }
    dBody.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      return '<div class="ed-dline">' +
        (img ? '<img src="' + img + '" alt="" width="76" height="95">' : '<span></span>') +
        '<div><b>' + esc(it.product_title) + '</b><small>' + esc(lineDetail(it)) + '</small>' +
        '<div class="ed-dline__qty"><button type="button" data-q="' + (i + 1) + '" data-v="' + (it.quantity - 1) + '" aria-label="Retirer un">−</button><span>' + it.quantity + '</span><button type="button" data-q="' + (i + 1) + '" data-v="' + (it.quantity + 1) + '" aria-label="Ajouter un">+</button></div></div>' +
        '<div class="ed-dline__price">' + money(it.final_line_price) + '<button type="button" class="ed-dline__rm" data-q="' + (i + 1) + '" data-v="0">Retirer</button></div></div>';
    }).join('');
  }
  function fetchCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; }); }

  if (drawer) {
    $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); if (menu) { menu.hidden = true; body.classList.remove('is-locked'); } } });
    $$('[data-cart-open]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); fetchCart().then(openDrawer); }); });
    if (dBody) dBody.addEventListener('click', function (e) {
      var b = e.target.closest('[data-q]'); if (!b) return;
      b.disabled = true;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +b.dataset.q, quantity: Math.max(0, +b.dataset.v) }) })
        .then(function (r) { return r.json(); }).then(renderCart).catch(fetchCart);
    });
    var noteTimer;
    function saveNote() {
      if (!noteEl) return Promise.resolve();
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: noteEl.value }) })
        .then(function () { if (noteStatus) noteStatus.textContent = 'Note enregistrée.'; });
    }
    if (noteEl) noteEl.addEventListener('input', function () { if (noteStatus) noteStatus.textContent = ''; clearTimeout(noteTimer); noteTimer = setTimeout(saveNote, 600); });
    var co = $('[data-checkout]');
    if (co) co.addEventListener('click', function (e) { e.preventDefault(); clearTimeout(noteTimer); saveNote().then(function () { location.href = '/checkout'; }, function () { location.href = '/checkout'; }); });
  }

  /* Product */
  $$('[data-product]').forEach(function (root) {
    var json = $('[data-variants]', root); if (!json) return;
    var variants = JSON.parse(json.textContent);
    var iO = +root.dataset.iOffer, iC = +root.dataset.iColor, iS = +root.dataset.iSize;
    var idInput = $('[data-variant-id]', root);
    var atc = $('[data-atc]', root), atcLabel = $('[data-atc-label]', root);
    var form = $('[data-atc-form]', root);
    var atcText = atcLabel ? atcLabel.textContent : 'Ajouter au panier';

    /* Upsell : produit en plus coché */
    var up = $('[data-upsell]', root), upList = [];
    if (up) {
      try { upList = JSON.parse($('[data-upsell-variants]', up).textContent).filter(Boolean); } catch (e) {}
      var upCheck = $('[data-upsell-check]', up);
      upCheck.addEventListener('change', function () { up.classList.toggle('is-on', upCheck.checked); });
    }
    function upsellItem() {
      if (!up || !$('[data-upsell-check]', up).checked) return null;
      var c = $('[data-upsell-color]', up).value, sz = $('[data-upsell-size]', up).value;
      var v = upList.filter(function (x) { return x.c === c && x.s === sz && x.a; })[0];
      return v ? { id: v.id, quantity: 1 } : null;
    }
    /* Lots panachés : un coloris et une taille par article */
    var mix = $('[data-mix]', root), mixLabel = mix ? $('.ed-mix__row b', mix).textContent.replace(/\s*\d+$/, '') : '';
    function showMix(n, c, s) {
      if (!mix) return;
      mix.hidden = n < 2;
      $$('[data-mix-row]', mix).forEach(function (row) {
        var k = +row.dataset.mixRow, on = k <= n;
        if (on && row.hidden) { $('[data-mix-color]', row).value = c; $('[data-mix-size]', row).value = s; }
        row.hidden = !on;
      });
    }
    function mixProps() {
      if (!mix || mix.hidden) return null;
      var p = {}; p[mixLabel + ' 1'] = val('color') + ' / ' + val('size');
      $$('[data-mix-row]', mix).forEach(function (row) {
        if (!row.hidden) p[mixLabel + ' ' + row.dataset.mixRow] = $('[data-mix-color]', row).value + ' / ' + $('[data-mix-size]', row).value;
      });
      return p;
    }
    var sticky = $('[data-sticky]');
    var current = null;
    var unitPrice = +root.dataset.unitPrice || 0;

    /* Présélection depuis l'URL : ?couleur=sable&lot=4 */
    var qs = new URLSearchParams(location.search);
    if (qs.get('couleur')) {
      var ci = $$('input[data-option="color"]', root).find(function (i) { return slug(i.value) === qs.get('couleur'); });
      if (ci) ci.checked = true;
    }
    if (qs.get('lot')) {
      var want = +qs.get('lot');
      var oi = $$('input[data-option="offer"]', root).find(function (i) {
        var vv = variants.find(function (x) { return x.options[iO] === i.value; });
        return vv && countOf(vv.sku) === want;
      });
      if (oi) oi.checked = true;
    }
    var fromUrlColor = !!qs.get('couleur');

    var val = function (name) { var c = $('input[data-option="' + name + '"]:checked', root); return c ? c.value : null; };
    var find = function (o, c, s) { return variants.find(function (v) { return v.options[iO] === o && v.options[iC] === c && v.options[iS] === s; }); };
    var anyAvail = function (test) { return variants.some(function (v) { return v.available && test(v); }); };

    function mark() {
      $$('input[data-option]', root).forEach(function (i) { i.closest('label').classList.toggle('is-on', i.checked); });
    }

    function update(fromColor) {
      var o = val('offer'), c = val('color'), s = val('size');
      // couleurs dispo pour cette offre
      $$('input[data-option="color"]', root).forEach(function (i) {
        i.closest('label').hidden = !anyAvail(function (v) { return v.options[iO] === o && v.options[iC] === i.value; });
      });
      var cIn = $('input[data-option="color"]:checked', root);
      if (cIn && cIn.closest('label').hidden) {
        var first = $$('input[data-option="color"]', root).find(function (i) { return !i.closest('label').hidden; });
        if (first) { first.checked = true; c = first.value; }
      }
      $$('input[data-option="size"]', root).forEach(function (i) {
        var v = find(o, c, i.value);
        i.closest('label').classList.toggle('is-out', !(v && v.available));
      });
      mark();
      var v = find(o, c, s);
      current = v;
      var cl = $('[data-color-label]', root); if (cl) cl.textContent = c;
      var sl = $('[data-size-label]', root); if (sl) sl.textContent = s;
      if (!v) { atc.disabled = true; atcLabel.textContent = 'Indisponible'; return; }
      idInput.value = v.id;
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? atcText : 'Indisponible';
      $$('[data-price]').forEach(function (el) { el.textContent = money(v.price); });
      var n = countOf(v.sku), ref = unitPrice * n, save = ref - v.price;
      showMix(n, c, s);
      var refEl = $('[data-ref]', root), saveEl = $('[data-save]', root);
      if (refEl) { refEl.hidden = !(save > 0); refEl.textContent = money(ref); }
      if (saveEl) { saveEl.hidden = !(save > 0); saveEl.textContent = 'Vous économisez ' + money(save); }
      var st = $('[data-sticky-title]'); if (st) st.textContent = c + ' · ' + s + ' · ' + (n > 1 ? 'Lot de ' + n : '1 legging');
      var si = $('[data-sticky-img]'), swImg = $('input[data-option="color"]:checked + img', root);
      if (si && swImg) si.src = swImg.src;
      if (history.replaceState && document.body.classList.contains('tpl-product')) {
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
      }
      if (fromColor) goColor(c);
    }

    $$('input[data-option]', root).forEach(function (i) {
      i.addEventListener('change', function () { update(i.dataset.option === 'color'); });
    });

    /* Gallery */
    var slides = $$('[data-slide]', root), thumbs = $$('[data-thumb]', root), idx = 0;
    var counter = $('[data-gallery-index]', root);
    function go(n) {
      if (!slides.length) return;
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === idx); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === idx); });
      if (counter) counter.textContent = idx + 1;
      var tb = thumbs[idx], strip = tb && tb.parentNode;
      if (strip && strip.scrollWidth > strip.clientWidth) {
        var l = tb.offsetLeft - strip.offsetLeft, r = l + tb.offsetWidth;
        if (l < strip.scrollLeft || r > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: l - 16, behavior: 'smooth' });
      }
    }
    function goColor(c) {
      var k = slides.findIndex(function (s) { return s.dataset.colorSlide === slug(c); });
      if (k > -1) go(k);
    }
    var prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.thumb); }); });
    var track = $('[data-gallery-track]', root), x0 = null, y0 = null;
    if (track) {
      track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(idx + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    }

    /* ETA */
    function addBusiness(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
    var fmt = function (d) { return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }); };
    var ef = $('[data-eta-from]', root), et = $('[data-eta-to]', root);
    if (ef && et) {
      var now = new Date();
      ef.textContent = fmt(addBusiness(now, +root.dataset.shipMin || 4));
      et.textContent = fmt(addBusiness(now, +root.dataset.shipMax || 9));
    }

    /* Add to cart */
    function add() {
      if (!current || !current.available) return;
      atc.disabled = true; atcLabel.textContent = 'Ajout…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [(function () { var it = { id: current.id, quantity: 1 }, p = mixProps(); if (p) it.properties = p; return it; })()].concat(upsellItem() || []) }) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { return fetchCart(); })
        .then(function () { openDrawer(); })
        .catch(function () { form.submit(); })
        .then(function () { atc.disabled = false; atcLabel.textContent = atcText; });
    }
    if (form) form.addEventListener('submit', function (e) { if (!drawer) return; e.preventDefault(); add(); });
    var sAtc = $('[data-sticky-atc]');
    if (sAtc) sAtc.addEventListener('click', add);

    /* Sticky */
    if (sticky && 'IntersectionObserver' in window) {
      var visible = true;
      var sio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { visible = e.isIntersecting; });
        var past = atc.getBoundingClientRect().top < 0;
        var on = !visible && past;
        sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      sio.observe(atc);
      window.addEventListener('scroll', function () {
        var on = !visible && atc.getBoundingClientRect().top < 0;
        if (on !== sticky.classList.contains('is-on')) { sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true'); }
      }, { passive: true });
    }

    update(fromUrlColor);
  });

  /* Avis : un à la fois, défilement auto */
  $$('[data-quotes]').forEach(function (box) {
    var items = $$('[data-quote]', box), dots = $$('[data-quote-dot]', box), cur = 0, timer;
    if (items.length < 2) return;
    var show = function (i) {
      cur = (i + items.length) % items.length;
      items.forEach(function (q, k) { q.classList.toggle('is-on', k === cur); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === cur); });
    };
    var start = function () { clearInterval(timer); timer = setInterval(function () { show(cur + 1); }, 6000); };
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); start(); }); });
    start();
  });

  /* Lien vers un onglet (#guide-des-tailles) : l'ouvre avant d'y descendre */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a || a.getAttribute('href').length < 2) return;
    var d = document.getElementById(a.getAttribute('href').slice(1));
    if (d && d.tagName === 'DETAILS') { e.preventDefault(); d.open = true; d.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  });

  /* Repères sur photo : positionnés par rapport à l'image (recadrée en object-fit: cover), pas au cadre */
  function placePins() {
    $$('.ed-split__img').forEach(function (box) {
      var img = $('img', box), pins = $$('[data-pin-x]', box);
      if (!img || !pins.length || !img.naturalWidth) return;
      var cw = box.clientWidth, ch = box.clientHeight, nw = img.naturalWidth, nh = img.naturalHeight;
      var sc = Math.max(cw / nw, ch / nh), w = nw * sc, h = nh * sc, ox = (cw - w) / 2, oy = (ch - h) / 2;
      pins.forEach(function (p) {
        p.style.left = (ox + w * p.dataset.pinX / 100 - p.offsetWidth / 2) + 'px';
        p.style.top = (oy + h * p.dataset.pinY / 100 - p.offsetHeight / 2) + 'px';
      });
    });
  }
  $$('.ed-split__img img').forEach(function (img) { if (img.complete) placePins(); else img.addEventListener('load', placePins); });
  window.addEventListener('resize', placePins);

  /* Carrousel d'avis */
  $$('[data-revs]').forEach(function (box) {
    var track = $('[data-revs-track]', box);
    var go = function (dir) {
      var max = track.scrollWidth - track.clientWidth;
      var to = track.scrollLeft + dir * track.clientWidth;
      if (dir > 0 && track.scrollLeft >= max - 4) to = 0;
      if (dir < 0 && track.scrollLeft <= 4) to = max;
      track.scrollTo({ left: to, behavior: 'smooth' });
    };
    var prev = $('[data-revs-prev]', box), next = $('[data-revs-next]', box);
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
  });

  /* Vidéos clientes : lecture au clic, une seule à la fois */
  $$('[data-ugc]').forEach(function (box) {
    var vids = $$('video', box);
    $$('[data-ugc-play]', box).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var fig = btn.parentNode, vid = $('video', fig);
        if (!vid) return;
        if (vid.paused) {
          vids.forEach(function (o) { if (o !== vid) { o.pause(); o.parentNode.classList.remove('is-playing'); } });
          vid.muted = false; vid.play(); fig.classList.add('is-playing');
        } else { vid.pause(); fig.classList.remove('is-playing'); }
      });
    });
    var next = $('[data-ugc-next]', box), track = $('[data-ugc-track]', box);
    if (next && track) next.addEventListener('click', function () {
      var end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      track.scrollTo({ left: end ? 0 : track.scrollLeft + track.clientWidth, behavior: 'smooth' });
    });
  });
})();
